import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'

export const startDateOptions = [
  {
    label: 'Offer acceptance date',
    value: true,
  },
  {
    label: 'Specific future date',
    value: false,
  },
]

export const ContractDurationOptions = [
  {
    label: 'Months',
    value: 'MONTHS',
  },
  {
    label: 'Years',
    value: 'YEARS',
  },
]

export const renewalOptions: RadioButtonGroupMapping[] = [
  {
    key: 'Yes',
    label: 'Yes',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'No',
    label: 'No',
    type: RadioButtonType.STANDARD,
  },
]

export const privateOfferExpirationDateField = {
  title: 'Offer expiration date',
  humanReadableKey: 'Offer expiration date',
  placeHolder: 'Offer expiration date',
  id: 'offerExpirationDate',
  isRequired: false,
  isReadOnly: false,
  isCustom: false,
  dataType: 'date',
  minDate: 'today',
}

export const privateOfferSubscriptionEndDateField = {
  title: 'Subscription end date',
  humanReadableKey: 'Subscription end date',
  placeHolder: 'Subscription end date',
  id: 'subscriptionEndDate',
  isRequired: false,
  isReadOnly: false,
  isCustom: false,
  dataType: 'date',
  minDate: 'today',
}
